import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from './authStore';
import { canViewPath } from './permissions';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps): JSX.Element {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const role = useAuthStore((s) => s.user?.role);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // Bereichs-Schutz fuer die Nur-Lesen-Rolle (CUR-995). Bewusst HIER und nicht
  // je Route: so ist jede Seite — auch eine spaeter ergaenzte — erst einmal
  // gesperrt, und der Schutz greift auch bei einer direkt eingetippten URL.
  // Umgeleitet wird auf die Uebersicht statt eine leere Seite zu zeigen.
  if (!canViewPath(role, location.pathname)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
